<div>

  <div class="main-div">
     <ng-container *ngIf="pageLoaded; else loadedBlock">
      <div>
        <mat-spinner style="margin: 0 auto" mode="indeterminate" [diameter]="200"></mat-spinner>
      </div>
    </ng-container>

    <ng-template #loadedBlock>
      <div *ngIf="!displayErrorMessage; else error">
        <div class="col-md-12 my-5">
          <div>
            <app-show-table [searchResults]="previousAnalysisKeys"></app-show-table>
          </div>
        </div>
      </div>
      <ng-template #error>
        <div class="error-box">{{errorMessage}}</div>
      </ng-template>
    </ng-template>
  </div>
</div>